import { IconProps } from '../icon';

export function EnvoyerIcon(props: IconProps) {
  return (
    <svg
      id="Envoyer"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="40"
      height="38.085"
      viewBox="0 0 40 38.085"
      {...props}
    >
      <defs>
        <clipPath id="clipPath">
          <rect
            id="Rectangle_341"
            data-name="Rectangle 341"
            width="40"
            height="38.085"
            fill="none"
          />
        </clipPath>
        <clipPath id="clipPath-3">
          <rect
            id="Rectangle_338"
            data-name="Rectangle 338"
            width="40"
            height="36.433"
            fill="none"
          />
        </clipPath>
        <clipPath id="clipPath-4">
          <rect
            id="Rectangle_339"
            data-name="Rectangle 339"
            width="32.788"
            height="37.893"
            fill="none"
          />
        </clipPath>
      </defs>
      <g id="Groupe_642" data-name="Groupe 642" clipPath="url(#clipPath)">
        <g id="Groupe_641" data-name="Groupe 641">
          <g id="Groupe_640" data-name="Groupe 640" clipPath="url(#clipPath)">
            <g id="Groupe_636" data-name="Groupe 636" opacity="0.6">
              <g id="Groupe_635" data-name="Groupe 635">
                <g
                  id="Groupe_634"
                  data-name="Groupe 634"
                  clipPath="url(#clipPath-3)"
                >
                  <path
                    id="Tracé_260"
                    data-name="Tracé 260"
                    d="M6.745,18.584Q3.686,16.1.627,13.609a1.365,1.365,0,0,1-.605-1.353A1.348,1.348,0,0,1,1.139,11.2Q7.772,9.281,14.4,7.343q8.391-2.438,16.783-4.87c2.748-.8,5.5-1.571,8.24-2.4.634-.192.637-.017.514.506-.764,3.263-1.505,6.531-2.258,9.8q-2.87,12.455-5.74,24.91a1.265,1.265,0,0,1-2.183.756c-2.151-1.728-4.286-3.474-6.43-5.21A3.382,3.382,0,0,0,23,30.625a46.238,46.238,0,0,0-3.793-3.191,36.232,36.232,0,0,0-3.525-2.789c.454-.523.879-1.075,1.367-1.565C24.426,15.678,31.842,8.315,39.132.827a.98.98,0,0,0,.4-.635L6.745,18.584"
                    transform="translate(0 0)"
                    fill="#92b72e"
                  />
                </g>
              </g>
            </g>
            <g
              id="Groupe_639"
              data-name="Groupe 639"
              transform="translate(6.745 0.192)"
              opacity="0.8"
            >
              <g id="Groupe_638" data-name="Groupe 638">
                <g
                  id="Groupe_637"
                  data-name="Groupe 637"
                  clipPath="url(#clipPath-4)"
                >
                  <path
                    id="Tracé_261"
                    data-name="Tracé 261"
                    d="M100.592,21.253,133.38,2.861a.98.98,0,0,1-.4.635c-7.29,7.488-14.706,14.851-22.083,22.253-.488.49-.913,1.042-1.367,1.565a.725.725,0,0,0-.143.183q-2.156,6.3-4.307,12.608c-.067.2-.189.389.051.554-.539.313-.408-.235-.447-.4-.382-1.641-.733-3.289-1.088-4.936q-1.5-6.956-3-13.913a.95.95,0,0,1-.008-.156"
                    transform="translate(-100.592 -2.861)"
                    fill="#92b72e"
                  />
                </g>
              </g>
            </g>
            <path
              id="Tracé_262"
              data-name="Tracé 262"
              d="M166.309,380.9c-.24-.164-.118-.358-.051-.554q2.153-6.3,4.307-12.608a.723.723,0,0,1,.143-.183,36.172,36.172,0,0,1,3.525,2.789,46.239,46.239,0,0,1,3.793,3.191L166.309,380.9"
              transform="translate(-155.025 -342.914)"
              fill="#92b72e"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default EnvoyerIcon;
